import * as actions from "./modal.actions";
import * as types from "./modal.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { ModalReducerType } from "./types";

export type UserAction = ActionType<typeof actions>;

export const initialState: ModalReducerType = {
  visible: false,
  title: '',
  description: ''
};

export const modalReducer = createReducer<
ModalReducerType,
  UserAction
>(initialState)
  .handleAction(types.SHOW_MODAL as any, (state, action) => ({
    ...state,
    visible: true,
    title: action.payload.title,
    description: action.payload.description,
  }))
  .handleAction(types.DISMISS_MODAL as any, (state, action) => ({
    ...state,
    visible: false,
    title: '',
    description: '',
  }));
